<template>
  <div id="trust-metter-page">
    <page-header-component icon="bi bi-diagram-3" title="Trust Meter" />
    <div class="row m-t-10">
      <div class="col-md-12 px-gap">
        <div class="card m-b-10 shade">
          <div class="card-body">
            <div class="row">
              <div class="col-md-8 col-sm-12">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Grafik Trust Meter</h4>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-6">
                <highcharts :options="configBar" :key="keyBar"></highcharts>
              </div>
              <div class="col-md-6 col-sm-6">
                <highcharts
                  :options="configSpider"
                  :key="keyBarSpider"
                ></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12 px-gap">
        <div class="card m-b-10 shade">
          <div class="card-body">
            <div class="row">
              <div class="col-md-8 col-sm-12">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Tren Public Trust Harian</h4>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <highcharts
                  :options="configLineDay"
                  :key="keyBarLine"
                ></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import page_header from "@/views/components/page_header.vue";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts/highcharts.js";
import HighchartsMore from "highcharts/highcharts-more.js";
HighchartsMore(Highcharts);

export default {
  name: "TrustMeter",
  title: "Analytics Trust Meter | Online Media Monitoring",
  components: {
    "page-header-component": page_header,
    highcharts: Chart,
  },
  data() {
    return {
      dataBar: {},
      dataBarSpider: {},
      dataLineDay: {},
      configBar: {},
      configBarSpider: {},
      configLineDay: {},
      configSpider: {},
      keyBar: 10,
      keyBarSpider: 20,
      keyBarLine: 30,
      id_project: this.$store.getters.user.id_project,
    };
  },
  methods: {
    fetchDataBar: function () {
      var self = this;
      var params = this.$route.query;
      if ("from" in params == false) {
        params.from = this.$store.getters.filter_date_from.format(
          "YYYY-MM-DD HH:mm:ss"
        );
        params.to = this.$store.getters.filter_date_to.format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }

      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if ("q" in params) {
        params.q = atob(params.q);
      }
      let api =
        process.env.VUE_APP_API_URL +
        "trust-meter/bar/" +
        this.id_project +
        "?" +
        query;
      this.$http
        .get(api)
        .then((resp) => {
          if (resp.status == 200) {
            this.dataBar = resp.data;
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(function () {
          self.getDataBar();
          self.getDataBarSpider();
        });
    },
    fetchDataLine: function () {
      var self = this;
      var params = this.$route.query;
      if ("from" in params == false) {
        params.from = this.$store.getters.filter_date_from.format(
          "YYYY-MM-DD HH:mm:ss"
        );
        params.to = this.$store.getters.filter_date_to.format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }

      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if ("q" in params) {
        params.q = atob(params.q);
      }
      let api =
        process.env.VUE_APP_API_URL +
        "trust-meter/line/" +
        this.id_project +
        "?" +
        query;
      this.$http
        .get(api)
        .then((resp) => {
          if (resp.status == 200) {
            this.dataLineDay = resp.data;
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(function () {
          self.getDataBarLine();
        });
    },
    getDataBar: function () {
      this.configBar = {
        chart: {
          type: "bar",
        },
        title: {
          text: "",
        },
        colors: ["#4572A7", "#28a745", "#343a3f", "#ffc007", "#dc3444"],

        xAxis: {
          categories: this.dataBar.categories,
          title: {
            text: null,
          },
        },
        yAxis: {
          min: 0,
          labels: {
            overflow: "justify",
          },
          title: {
            text: "Jumlah Emotions",
          },
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
            },
          },
          series: {
            colorByPoint: true,
          },
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Emotions",
            data: this.dataBar.series,
          },
        ],
      };
      this.keyBar++;
    },
    getDataBarSpider: function () {
      this.configSpider = {
        chart: {
          polar: true,
          type: "line",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "",
          x: -80,
        },
        pane: {
          size: "90%",
        },
        xAxis: {
          categories: this.dataBar.categories,
          tickmarkPlacement: "on",
          lineWidth: 0,
        },
        yAxis: {
          gridLineInterpolation: "polygon",
          lineWidth: 0,
          min: 0,
        },
        series: [
          {
            name: "Emotions",
            data: this.dataBar.series,
            pointPlacement: "on",
          },
        ],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                pane: {
                  size: "80%",
                },
              },
            },
          ],
        },
      };
      this.keyBarSpider++;
    },
    getDataBarLine: function () {
      this.configLineDay = {
        chart: {
          type: "line",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: this.dataLineDay.date,
          title: {
            text: null,
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
            },
            enableMouseTracking: true,
          },
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Joy",
            data: this.dataLineDay.joy,
            color: "#28a745",
          },
          {
            name: "Fear",
            data: this.dataLineDay.fear,
            color: "#343a3f",
          },
          {
            name: "Sad",
            data: this.dataLineDay.sad,
            color: "#ffc007",
          },
          {
            name: "Anger",
            data: this.dataLineDay.anger,
            color: "#dc3444",
          },
          {
            name: "No Emotion",
            data: this.dataLineDay.no_emotion,
            color: "#4572A7",
          },
        ],
      };
      this.keyBarLine++;
    },
  },
  watch: {
    $route: {
      immediate: false,
      handler() {
        this.fetchDataBar();
        this.fetchDataLine();
      },
    },
  },
  mounted: function () {
    this.fetchDataBar();
    this.fetchDataLine();
  },
};
</script>
